import axios from "axios";
import { AdminUserSearchDto } from "./models/adminUserSearchDto";
import { AdvancedFilterOptions } from "../../../Common/models/advancedFilters";
import { AdvancedFiltersType } from "../../../Common/models/advancedFiltersType";

export const getUsers = async (searchValue?: string): Promise<AdminUserSearchDto[]> => {
  const { data: users } = await axios.get<AdminUserSearchDto[]>(
    `${window.configuration.apiUrl}api/users/admin/search?searchValue=${searchValue}`,
  );

  return users;
};

export const getAdvancedFilters = async (): Promise<AdvancedFilterOptions> => {
  const { data } = await axios.get<AdvancedFilterOptions>(
    `${window.configuration.apiUrl}api/users/advancedfilters`,
    {
      params: {
        advancedFiltersType: AdvancedFiltersType.AdminAf,
      },
    }
  );
  return data;
};

export const getUsersByAdvancedFilters = async (filters: AdvancedFilterOptions, searchValue?: string): Promise<AdminUserSearchDto[]> => {
  const { data: users } = await axios.post<AdminUserSearchDto[]>(
    `${window.configuration.apiUrl}api/users/admin/search/advanced?searchValue=${searchValue}`,
    filters,
  );

  return users;
};

export const exportUsersByAdvancedFilters = async (filters: AdvancedFilterOptions, searchValue?: string): Promise<void> => {
  const response = await axios.post(
    `${window.configuration.apiUrl}api/users/admin/search/advanced/export?searchValue=${searchValue}`,
    filters,
    { responseType: "blob" },
  );

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  const contentDisposition = response.headers["content-disposition"];
  let fileName = "users.csv";
  if (contentDisposition) {
    const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
    if (fileNameMatch && fileNameMatch.length === 2) fileName = fileNameMatch[1].split(";")[0].trim();
  }
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
};
